import React from 'react';

export default function RmSendButton({ disabled, fontSize, onClick, style }) {
    const color = disabled ? '#ffffff66' : '#ffffff';
    const cursor = disabled ? 'not-allowed' : 'pointer';
    const iconStyle = { fontSize, color, cursor, ...style };

    function handleClick() {
        if (!disabled) onClick();
    }

    return (
        <i className="material-icons" style={iconStyle} onClick={handleClick}>
            send
        </i>
    );
}

RmSendButton.defaultProps = {
    disabled: false,
    fontSize: '14px',
};
